import type { ChartDataPoint } from '../components/PositionProgressChart'
import type { PositionAssessmentTimeseriesItem } from '../types'

/**
 * Process position assessments timeseries data for chart display.
 * Groups by date and separates manager vs self scores.
 */
export const processTimeseries = (
  timeseries: Array<PositionAssessmentTimeseriesItem> | undefined,
): Array<ChartDataPoint> => {
  if (!timeseries || timeseries.length === 0) return []

  // Group by completedAt date, keeping separate entries for manager and self
  const groupedByDate = new Map<string, { manager?: number; self?: number }>()

  timeseries.forEach((item) => {
    if (!item.assessmentCreatedAt) return

    // Extract just the date part (YYYY-MM-DD) to group by date only
    const dateOnly = item.assessmentCreatedAt
    if (!item.overallAvg) return
    const score = parseFloat(item.overallAvg)

    if (!groupedByDate.has(dateOnly)) {
      groupedByDate.set(dateOnly, {})
    }

    const group = groupedByDate.get(dateOnly)!
    if (item.responseType === 'manager') {
      group.manager = score
    } else {
      group.self = score
    }
  })

  // Convert to chart data format
  return Array.from(groupedByDate.entries())
    .map(([dateStr, scores]) => {
      const date = new Date(dateStr)
      return {
        date: dateStr,
        displayDate: date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
        }),
        managerScore: scores.manager ?? null,
        directReportScore: scores.self ?? null,
      }
    })
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
}
